import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config/config';

const RecentPosts = ({ userId }) => {
  const [recentPosts, setRecentPosts] = useState([]);

  const fetchRecentPosts = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Create the form data
      const formData = new URLSearchParams();
      formData.append('user_id', userId);

      // Send the POST request with form data
      const response = await axios.post(
        `${config.baseURL}/get-recent-posts`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      setRecentPosts(response.data.images || []);
    } catch (error) {
      console.error('Error fetching recent posts:', error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchRecentPosts();
    }
  }, [userId]);

  if (recentPosts.length === 0) {
    return null;
  }

  return (
    <div className="subscription_wrapper recent_post_view">
      <div className="subscription_head">RECENT</div>
      <div className="image_posts_grid">
        {recentPosts.map(image => (
          <a 
            href={`/${image.post_id}/${image.user_name || ''}`} 
            key={image.post_id} 
          >
            <img src={image.url} alt={`Post by ${image.user?.user_name || 'unknown user'}`} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default RecentPosts;
